import { render, staticRenderFns } from "./delivered_orders_table.vue?vue&type=template&id=0f42a82e&lang=pug&"
import script from "./delivered_orders_table.vue?vue&type=script&lang=js&"
export * from "./delivered_orders_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports